// declare Tapfiliate's tap function
const { tap } = window as any;

// track conversion
// https://tapfiliate.com/docs/javascript/#conversion
// notice orderAmount should be in dollar, not cent
export const trackTapfiliateConversion = (
  chargeId: string,
  orderAmount: number,
  customerId: string,
  currency?: string
) => {
  if (process.env.REACT_APP_ENV === "production") {
    tap("conversion", chargeId, orderAmount, {
      customer_id: customerId,
      currency,
    });
  }
};

export const trackTapfiliateCustomer = (stripeCustomerId: string) => {
  if (process.env.REACT_APP_ENV === "production") {
    tap("trial", stripeCustomerId);
  }
};
